export const accountAuthSection = {
  login: {
    title: 'Вход в личный кабинет',
    description: 'Введите email, на который оформили билет. Мы отправим код подтверждения.',
    emailLabel: 'Email',
    emailPlaceholder: 'name@example.com',
    submit: 'Получить код',
    submitting: 'Отправка...'
  },
  verify: {
    title: 'Подтверждение email',
    description: 'Мы отправили код подтверждения на ваш email. Введите его ниже.',
    codeLabel: 'Код из письма',
    codePlaceholder: 'Код',
    submit: 'Войти',
    submitting: 'Загрузка...',
    resend: 'Отправить код повторно',
    resending: 'Отправка...',
    back: '← Изменить email'
  }
};
